import { useTranslation } from 'react-i18next';

import { Badge, type BadgeProps } from '@/shared/ui/badge';

type BadgeVariant = NonNullable<BadgeProps['variant']>;

const STATUS_VARIANT: Record<string, BadgeVariant> = {
  draft: 'muted',
  in_progress: 'default',
  pending_completion: 'secondary',
  pending_signature: 'secondary',
  closed: 'success',
  addended: 'success',
  cancelled: 'destructive',
  voided: 'muted',
};

export function ClinicalVisitStatusBadge({ status }: { status: string }): JSX.Element {
  const { t } = useTranslation();
  const variant = STATUS_VARIANT[status] ?? 'muted';
  return <Badge variant={variant}>{t(`clinical.status_${status}`)}</Badge>;
}
